import queryString from 'query-string';
import { AxiosResponse } from 'axios';
import HttpClient, { Metadata } from '../utils/HttpClientHandler';
import { Job } from '../types/Job';
import { FEATURES } from '../types/Feature';
import PaginationHandler from '../utils/PaginationHandler';

const JobService = class JobService {
    #baseURL: string;

    jobFeatureCriterion: string;

    constructor(jobFeatureCriterion = FEATURES.AUTO_STACKING as string) {
        this.jobFeatureCriterion = jobFeatureCriterion;
        this.#baseURL = '/v2/jobs';
    }

    // @christianjtr : Should be an utils function...
    private setQueryStringParams(filters: { [key: string]: any }): string {
        return queryString.stringify(filters, { arrayFormat: 'comma', skipEmptyString: true, skipNull: true });
    }

    public async getAllJobs(filters = {}): Promise<{ data: Job[]; _metadata: Metadata }> {
        const qsFilters = Object.keys(filters).length !== 0 ? `?${this.setQueryStringParams(filters)}` : '';
        const response: AxiosResponse = await HttpClient.get(
            `${this.#baseURL}/${this.jobFeatureCriterion}${qsFilters}`,
        );

        const { data, headers }: { data: Job[]; headers: any } = response;
        return {
            data,
            _metadata: {
                pagination: new PaginationHandler(headers),
            },
        };
    }

    public async getJobById(jobId: number): Promise<Job> {
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}/${jobId}`);
        const { data }: { data: Job } = response;
        return data;
    }

    public async releaseJob(jobId: number): Promise<Job> {
        const response: AxiosResponse = await HttpClient.post(`${this.#baseURL}/${jobId}/release`);
        const { data }: { data: Job } = response;
        return data;
    }
};

export default new JobService();
